import type { TranslationFunction } from "../../lib/preferences";

const reasons: Record<string, string> = {
  policy_violation: "Policy violation",
  duplicate_account: "Duplicate account",
  incomplete_data: "Incomplete information",
  fraud_risk: "Verification concern",
  other: "Other",
};

// Older review records store the reason as a prefix in the note. Present known
// codes as readable labels while preserving unknown prefixes and the full note.
export function formatProviderReviewNote(note: string, t: TranslationFunction): string {
  const match = /^\[([^\]]+)\]\s*([\s\S]*)$/.exec(note);
  if (!match || !reasons[match[1]!]) return note;
  return `${t(reasons[match[1]!]!)}: ${match[2]}`;
}
